import * as z from "zod";
import { definitionInputSchema, diagnosticSchema } from "./common";

/** Checks a definition without saving it. A document that isn't an automation is one error diagnostic. */
export const validate = {
  name: "validate" as const,
  input: z.object({ definition: definitionInputSchema }),
  output: z.object({ diagnostics: z.array(diagnosticSchema) }),
};
